module.exports = __webpack_public_path__ + "img/p-3.62c6ed74.png";